<div class="w-full h-full">
  <div *ngIf="step === -1" class="w-full h-full">
    <app-invest-document-viewfinder (prevEvent)="removeModal()" (goToSignDocuments)="continue()"
      [documents]="signDocuments"></app-invest-document-viewfinder>
  </div>
  <div *ngIf="step === 0">
    <fun-overal-message [text]="text" [image]="image" [btnList]="btnList" (btnEvent)="continue()"></fun-overal-message>
  </div>
  <div *ngIf="step === 1" class="w-full h-full">
    <fun-formalize-signature [projectId]="movement.projectId" [investId]="movement.id" (signedEvent)="signed()"
      (removeModalEvent)="removeModal()"></fun-formalize-signature>
  </div>
</div>